// @flow
import { Platform } from 'react-native';
import RNRestart from 'react-native-restart';
import SplashScreen from 'react-native-splash-screen';
import { takeEvery, call, put, select } from 'redux-saga/effects';
import { tripica } from '../../api';
import HandleErrorService from '../../lib/handleError';
import { setLoading } from '../LoadingStatus';
import type { LocalizationAction } from './actions';
import { setLocale } from './actions';
import { deviceIdSelector } from '../Authentication/selectors';
import WizzeeLog from '../../lib/wizzeeLog';

export function* updateLocaleSaga(action: LocalizationAction): Generator<*, *, *> {
  if (action.type !== 'UPDATE_LOCALE') return; // for flow

  try {
    const { locale } = action.payload;
    yield put(setLoading('updateLocale', true));
    const deviceId = yield select(deviceIdSelector);
    yield put(setLocale(locale));
    yield call([tripica, 'updateLocale'], locale, deviceId);

    if (Platform.OS === 'android') {
      // it doesn't work on iOS
      SplashScreen.show();
    }
    yield call([RNRestart, 'Restart']);
  } catch (e) {
    WizzeeLog.warn('[saga] updateLocale', e);
    HandleErrorService.showToastError(e);
  } finally {
    yield put(setLoading('updateLocale', false));
  }
}

export default function*(): Generator<*, *, *> {
  yield* [takeEvery('UPDATE_LOCALE', updateLocaleSaga)];
}
